import { render, staticRenderFns } from "./RiOverview.vue?vue&type=template&id=8d68c2f8&scoped=true"
import script from "./RiOverview.vue?vue&type=script&lang=js"
export * from "./RiOverview.vue?vue&type=script&lang=js"
import style0 from "./RiOverview.vue?vue&type=style&index=0&id=8d68c2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d68c2f8",
  null
  
)

export default component.exports